// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { AbstractViewModel } from '@front/webmobile/ViewModels/AbstractViewModel';
import { QuickTreeNode } from '../elements/QuickTree/QuickTreeNode';
import { Resources } from '@shared/localizations/Resources';
import { ControlsUtils } from '../UtilsClasses/ControlsUtils';
import EventEmitter from 'events';
export class LookupDropDownFormProps {
    constructor() {
        this.items = [];
        this.selectedItem = null;
    }
}
export class LookupDropDownFormComponentView {
    constructor() {
        this.x = 0;
        this.y = 0;
        this.isMultiSelect = false;
    }
}
export class LookupDropDownFormViewModel extends AbstractViewModel {
    get selectAllText() {
        return this.componentView.selectAllText;
    }
    set selectAllText(value) {
        this.updateComponentView('selectAllText', value);
    }
    get multiSelectText() {
        return this.componentView.multiSelectText;
    }
    set multiSelectText(value) {
        this.updateComponentView('multiSelectText', value);
    }
    get cancelBtnText() {
        return this.componentView.cancelBtnText;
    }
    set cancelBtnText(value) {
        this.updateComponentView('cancelBtnText', value);
    }
    get addBtnText() {
        return this.componentView.addBtnText;
    }
    set addBtnText(value) {
        this.updateComponentView('addBtnText', value);
    }
    get enabledAddBtn() {
        return this.componentView.enabledAddBtn;
    }
    set enabledAddBtn(value) {
        this.updateComponentView('enabledAddBtn', value);
    }
    get isMultiSelect() {
        return this.componentView.isMultiSelect;
    }
    set isMultiSelect(value) {
        this.updateComponentView('isMultiSelect', value);
    }
    get textBoxPlaceholder() {
        return this.componentView.textBoxPlaceholder;
    }
    set textBoxPlaceholder(value) {
        this.updateComponentView('textBoxPlaceholder', value);
    }
    get x() {
        return this.componentView.x;
    }
    set x(value) {
        this.updateComponentView('x', value);
    }
    get y() {
        return this.componentView.y;
    }
    set y(value) {
        this.updateComponentView('y', value);
    }
    get currentNameFilter() {
        return this.componentView.currentNameFilter;
    }
    set currentNameFilter(value) {
        this.updateComponentView('currentNameFilter', value);
    }
    get textBoxValue() {
        return this.componentView.textBoxValue;
    }
    set textBoxValue(value) {
        this.updateComponentView('textBoxValue', value);
    }
    constructor(componentView) {
        super(componentView);
        this.eventEmitter = new EventEmitter();
        this.themeChange();
    }
    initialize(props) {
        super.initialize(props);
        this.props = props;
        this.setLocation(props.x, props.y, this.props.width, this.props.height, props.isCentered);
        this.fillTree();
        this.selectionChanged();
        this.localize();
    }
    update(props, prevProps) {
        super.update(props, prevProps);
        this.props = props;
        if (props.items !== prevProps.items) {
            this.fillTree();
        }
    }
    // public override oncomplete (): void {
    //     super.oncomplete();
    //     this.initializationComponents();
    //     this.on(ControlEvents.LostFocus, function () {
    //         // remove call stack overflow
    //         const caller = this.caller;
    //         this.caller = null;
    //         // TODO unificate  AfterLostFocusWaiting
    //         if (!isNullOrUndefined(caller) && !this.AfterLostFocusWaiting) {
    //             caller.setFocus();
    //         }
    //         if (this.autoClose) {
    //             if (!isNullOrUndefined(this.closeCallback)) {
    //                 this.closeCallback();
    //                 this.closeCallback = null;
    //             }
    //             this.set('visible', false);
    //         }
    //     }.bind(this));
    // }
    localize() {
        this.selectAllText = Resources.getResource('TerceraAccountLookup.Select All');
        this.multiSelectText = Resources.getResource('TerceraAccountLookup.Multy select');
        this.cancelBtnText = Resources.getResource('panel.TerceraSymbolLookupDropDownForm.Cancel');
        this.textBoxPlaceholder = Resources.getResource('screen.lookup.scripts.watermark');
    }
    onMultiSelectCheckboxClick(newValue) {
        this.isMultiSelect = newValue;
    }
    onQuickTreeDoubleClick() {
        if (this.quickTree.isMultiSelectCheckboxUsing) {
            return;
        }
        this.onAddBtnClicked(false); // #84756 (2nd issue)
        this.close();
    }
    onTextBoxValueChanged(value) {
        this.textBoxValue = value;
        this.currentNameFilter = value === '' ? null : value.toLowerCase();
        this.populateAsync();
    }
    subscribeOnResizeQuickTree(callback) {
        this.eventEmitter.on('onResizeQuickTree', callback);
    }
    unsubscribeOnResizeQuickTree(callback) {
        this.eventEmitter.off('onResizeQuickTree', callback);
    }
    initializationComponents() {
        throw new Error('Not implemented');
    }
    onAddBtnClicked(isBtnClick = false) {
        var _a;
        if (isBtnClick && !this.enabledAddBtn) {
            return;
        }
        const qt = this.quickTree;
        if (this.isMultiSelect) {
            if (!isNullOrUndefined(this.props.onSelect) && !isNullOrUndefined(qt.selectedNodesDict)) {
                let result = [];
                const dict = qt.selectedNodesDict;
                const keys = Object.keys(dict);
                const len = keys.length;
                for (let i = 0; i < len; i++) {
                    const curNode = dict[keys[i]];
                    if (((_a = curNode.childNodes) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                        result = result.concat(this.recursionAddCheckedResults(curNode.childNodes));
                    }
                    else if (!isNullOrUndefined(curNode.tag) && this.isValidResult(curNode.tag)) {
                        result.push(curNode.tag);
                    }
                }
                this.props.onSelect(result);
            }
        }
        else if (!isNullOrUndefined(this.props.onSelect) && !isNullOrUndefined(qt.selectedNode)) {
            this.props.onSelect(qt.selectedNode.tag);
        }
        this.close();
    }
    onEnterPressed() {
        // TODO.
        if (!this.enabledAddBtn) {
            return;
        }
        this.onAddBtnClicked(false);
    }
    selectionChanged() {
        const qt = this.quickTree;
        if (this.isMultiSelect) {
            const len = this.getSelectedNodesCount();
            this.addBtnText =
                Resources.getResource('panel.TerceraSymbolLookupDropDownForm.Add') + (len ? '[' + len + ']' : '');
            this.enabledAddBtn = this.isButtonAddEnable();
            this.changeCheckedNodes(qt);
            qt.Draw();
        }
        else {
            this.addBtnText = Resources.getResource('panel.TerceraSymbolLookupDropDownForm.Add');
            this.enabledAddBtn = this.isButtonAddEnable();
        }
    }
    changeCheckedNodes(quickTree) {
        const qt = quickTree;
        const nodesArr = qt.nodeCollection;
        if (nodesArr.length > 0) {
            for (const node of nodesArr) {
                const childNodesArr = node.childNodes;
                if (childNodesArr.length > 0) {
                    node.checked = true;
                    for (const child of childNodesArr) {
                        if (qt.selectedNodesDict[child.nodeText + node.nodeText]) {
                            child.checked = true;
                        }
                        else {
                            child.checked = false;
                            node.checked = false;
                        }
                    }
                }
            }
        }
    }
    getSelectedNodesCount() {
        const qt = this.quickTree;
        return !isNullOrUndefined(qt.selectedNodesDict) ? Object.keys(qt.selectedNodesDict).length : 0;
    }
    isButtonAddEnable() {
        var _a;
        const qt = this.quickTree;
        if (this.isMultiSelect) {
            const len = !isNullOrUndefined(qt.selectedNodesDict) ? Object.keys(qt.selectedNodesDict).length : 0;
            return !!len;
        }
        else {
            return !isNullOrUndefined((_a = qt.selectedNode) === null || _a === void 0 ? void 0 : _a.tag);
        }
    }
    recursionAddCheckedResults(nodes) {
        let result = [];
        const len = nodes.length;
        for (let i = 0; i < len; i++) {
            const curNode = nodes[i];
            if (curNode.childNodes.length > 0) {
                result = result.concat(this.recursionAddCheckedResults(curNode.childNodes));
            }
            else if (!isNullOrUndefined(curNode.tag) && this.isValidResult(curNode.tag)) {
                result.push(curNode.tag);
            }
        }
        return result;
    }
    close() {
        this.props.onClose();
    }
    onQuickTreeCreated(quickTree) {
        this.quickTree = quickTree;
    }
    populateAsync() {
        clearTimeout(this.asyncPopulateInterval);
        this.asyncPopulateInterval = null;
        this.asyncPopulateInterval = setTimeout(this.fillTree.bind(this), 300);
    }
    fillTree() {
        const items = this.props.items;
        const selectedItem = this.props.selectedItem;
        let selectedNode;
        const len = items.length;
        const nodeRange = [];
        for (let i = 0; i < len; i++) {
            const curItem = items[i];
            if (this.currentNameFilter !== null) {
                const curItemFindStr = curItem.toString().toLowerCase();
                if (!curItemFindStr.includes(this.currentNameFilter)) {
                    continue;
                }
            }
            const node = new QuickTreeNode(curItem.toString());
            node.tag = curItem;
            if (selectedItem === curItem) {
                selectedNode = node;
                node.selected = true;
            }
            nodeRange.push(node);
        }
        this.quickTree.Clear();
        this.quickTree.AddNodeRange(nodeRange);
        this.quickTree.setSelectedNode(selectedNode);
        this.quickTree.goToSelectedNode();
        this.quickTree.Draw();
    }
    raiseOnResizeQuickTree() {
        this.eventEmitter.emit('onResizeQuickTree');
    }
    isValidResult(nodeTag) {
        return true;
    }
    themeChange() { }
    setLocation(x, y, width, height, isCentered) {
        if (isCentered) {
            const { x: centerX, y: centerY } = ControlsUtils.centerPosition(width, height);
            this.x = centerX;
            this.y = centerY;
        }
        else {
            const { x: correctX, y: correctY } = ControlsUtils.adjustPositionToFitWindow(x, y, width, height);
            this.x = correctX;
            this.y = correctY;
        }
    }
}
